import React from "react"
import {Menu, Dropdown, Button} from "antd"
import {Icon} from "components/Icon"
import {handleError, toastError} from "helpers"
import styles from "./ShiftItem.module.css"
import {useMutation} from "@tanstack/react-query"
import {academicTrackPhasesAndShiftsTemplatesService} from "services"

type Props = {
    shift: {
        shiftName: string
        shiftId: number
        academicTrackPhaseShiftTemplateShiftId: number
    }
    reloadView: () => void
}

export function ShiftItem(props: Props) {
    const {shift, reloadView} = props

    const deleteShiftMutation = useMutation(academicTrackPhasesAndShiftsTemplatesService.deleteShiftTemplate, {
        onSuccess: () => {
            reloadView()
        },
        onError: () => {
            toastError("Failed to remove shift")
        }
    })

    const onDeleteShift = () => {
        deleteShiftMutation.mutate({
            academicTrackPhaseShiftTemplateShiftIds: [shift.academicTrackPhaseShiftTemplateShiftId]
        })
    }

    const renderMenuOptions = () => {
        return (
            <Menu className={styles.menuActionWrap}>
                <Menu.Item key="delete" className={styles.menuActionItem} onClick={onDeleteShift}>
                    <Icon className={styles.menuActionIcon} icon="DELETE" />
                    <span className={styles.menuActionTitle}>Remove Shift</span>
                </Menu.Item>
            </Menu>
        )
    }

    return (
        <div className={styles.courseItem}>
            <div className={styles.bodyWrap}>
                <div className={styles.courseItemDetail}>
                    <div className={styles.courseItemDetail__left}>
                        <span className={styles.courseItemDetail__left__courseName}>{shift.shiftName}</span>
                    </div>
                    <div className={styles.courseItemDetail__action}>
                        <Dropdown overlay={renderMenuOptions} trigger={["click"]}>
                            <Button
                                className={styles.iconBtn}
                                icon={<Icon className={styles.threeDotsIcon} icon="MORE_VERTICAL" color="#939393" />}
                            />
                        </Dropdown>
                    </div>
                </div>
            </div>
        </div>
    )
}
